module.exports = __webpack_public_path__ + "static/media/Limin Chung.434da017.png";